import React, { useEffect, useState } from 'react'
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import Select from 'react-select';
import {
    CButton,
    CFormLabel,
} from "@coreui/react";
import SaveExtra from "../../services/general/saveExtraData.api";
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import CheckOptionSelections from '../../components/shared/CheckOptionSelections';
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
const SuggestionCopy = ({ setParentAccordions, parentId = null, setSuggestionModalVisible, type = 'assessment', ApiCallingType = 'AssesmentSuggestions', differentModuleCopyFunctionality = false }) => {

    const [suggestionData, setSuggestionData] = useState([])
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
    const [diagnosisOptions, setDiagnosisOptions] = useState([]);
    const [selectedTitles, setSelectedTitles] = useState([]);
    const [titleOptions, setTitleOptions] = useState([])
    const [statementOption, setStatementOption] = useState([]);
    const [selectedStatement, setSelectedStatement] = useState([])
    const [planOptions, setPlanOptions] = useState([])
    const [selectedPlan, setSelectedPlan] = useState([])
    const [questionData, setQuestionData] = useState(null)
    const [selectedModuleType, setSelectedModuleType] = useState({ value: 'AssesmentSuggestions', label: 'Assessment' })
    const [moduleType, setModuleType] = useState([
        { value: 'HPI', label: 'HPI' },
        { value: 'followup', label: 'Follow Up' },
        { value: 'Incident', label: 'Incident' },
        { value: 'AssesmentSuggestions', label: 'Assessment' },
        { value: 'differentialDiagnosis', label: 'Differential Diagnosis' },
        { value: 'generalPlanStatements', label: 'Template' }
    ])


    const extractLinkedAssessments = (data) => {

        const processOptions = (options) =>
            options?.reduce((acc, option) => {
                if (option.linkedAssessment) {
                    acc.push(...option.linkedAssessment);
                }
                if (option.linkedQuestion) {
                    if (Array.isArray(option.linkedQuestion)) {
                        option.linkedQuestion.forEach((nestedQuestion) => {
                            acc.push(...processOptions(nestedQuestion.options));
                        });
                    } else if (typeof option.linkedQuestion === "object") {
                        acc.push(...processOptions(option.linkedQuestion.options));
                    }
                }

                return acc;
            }, []) || [];

        return data?.questionData?.reduce((acc, question) => {
            acc.push(...processOptions(question.options));
            return acc;
        }, []) || [];
    };

    const getData = async (type = 'AssesmentSuggestions') => {
        setIsPageLoading(true)
        try {
            if (type === 'AssesmentSuggestions' || type === 'differentialDiagnosis' || type === 'generalPlanStatements') {
                let data = await SaveExtra('Get_By_Type', type, '', '')
                data = JSON.parse(data.d)?.Data || [];
                if (data) {
                    data = data?.map((item) => {
                        return {
                            Id: item.Id,
                            Data: JSON.parse(item?.JsonData)
                        }
                    })
                }
                let result = data.filter((item) => item?.Data.diagnosis.value === selectedDiagnosis?.value)

                if (result.length > 0) {
                    handleAllTitles(result[0].Data.accordions)
                } else {
                    // setAccordions({ diagnosis: selectedDiagnosis || null, accordions: [] })
                    setTitleOptions([])
                    setStatementOption([])
                }

                setSuggestionData(data);

            } else if (type === 'HPI' || type === 'Incident' || type === 'followup') {
                let formattedData;
                if (selectedDiagnosis) {
                    formattedData = await SaveQuestionProvider('GET', "", type, selectedDiagnosis?.value?.toString(), '')
                    if (formattedData) {
                        formattedData = JSON.parse(formattedData.d)?.Data || []
                        formattedData = formattedData[0] || []
                        if (formattedData.questionData) {
                            formattedData = {
                                ...formattedData,
                                questionData: JSON.parse(formattedData.questionData).filter(item => item !== null)
                            }
                        }
                        if (formattedData) {
                            const linkedAssessments = extractLinkedAssessments(formattedData);
                            if (linkedAssessments.length > 0) {
                                handleAllTitles(linkedAssessments)
                            } else {
                                setTitleOptions([])
                                setStatementOption([])
                            }
                            setQuestionData(linkedAssessments)
                        }
                    }
                } else {
                    // window.alert("Please Select Diagnosis  ")
                }
            }
            // setSelectedDiagnosis(parentDiagnosis)

        } catch (error) {
            console.log(error)
        } finally {
            setIsPageLoading(false);
        }
    };


    const updateDiagnosisOptions = async () => {

        try {
            let response = await GetDiagnosisData("");
            let diagnosis = JSON.parse(response.d)?.Data;
            const options = diagnosis.map((item) => ({
                value: item.id,
                label: item.Name,
            }));
            setDiagnosisOptions(options);
        } catch (error) {
            console.error("Error updating diagnosis options:", error);
        }

    };


    const handlePlanStatement = (planStatement) => {
        const extractSuggestions = (accordions) => {
            return accordions.flatMap((accordion) => {
                const currentSuggestions = accordion.suggestions.suggestionName || [];
                const childSuggestions = accordion.children?.length > 0 ? extractSuggestions(accordion.children) : [];
                return [...currentSuggestions, ...childSuggestions];
            });
        };
        const planSuggestions = planStatement.flatMap((plan) => {
            return statementOption.flatMap((option) => {
                const matchingPlan = option.orders.planSuggestions?.find((planSuggestion) => planSuggestion.name === plan.label);

                if (matchingPlan && matchingPlan.accordions?.length > 0) {
                    return extractSuggestions(matchingPlan.accordions);
                }

                return [];
            });
        });
        console.log("planSuggestions", planSuggestions)
        if (planSuggestions.length > 0) {
            setPlanOptions(() => {
                let options = planSuggestions.map((plan, i) => {
                    return {
                        value: i,
                        label: plan.name,
                        description: plan.description,
                    }
                })
                return options.filter(options => options.label)
            })
        }
    };


    const handleAllStatement = (statements) => {

        try {
            const extractStatements = (item) => {

                const currentSuggestions = item?.suggestions || [];
                const childSuggestions =
                    item?.children && item.children.length > 0
                        ? item.children.flatMap((child) => extractStatements(child))
                        : [];

                return [currentSuggestions, ...childSuggestions];
            };

            const allStatements = statements.flatMap((item) => extractStatements(item.data));

            if (allStatements.length > 0) {
                let filterSuggestion = allStatements.map((item, i) => {
                    let suggestions = item?.suggestionName?.map((statement, index) => {
                        return {
                            value: statement,
                            label: statement.name || statement,
                            orders: item.orders.filter((order) => order.name === statement.name),
                            planSuggestions: item.planSuggestions.filter((plan) => plan.name === statement.name),
                        }
                    })
                    return {
                        data: suggestions,
                        orders: item
                    }
                })
                setStatementOption(filterSuggestion)
            }
        } catch (error) {
            console.error("Error handling all statements:", error);
        }

    };


    const handleAllTitles = (allSuggestionsFromAccordions) => {
        try {

            const extractOptions = (items) => {
                return items.flatMap((item) => {
                    const option = {
                        value: item.id,
                        label: item.title,
                        data: item,
                    };

                    const childOptions = item.children ? extractOptions(item.children) : [];
                    return [option, ...childOptions];
                });
            };

            // const title = extractOptions(allSuggestionsFromAccordions);
            const statement = extractOptions(allSuggestionsFromAccordions);
            const title = statement.filter((option) => option.label);
            setTitleOptions(title)

            handleAllStatement(statement)
        } catch (error) {
            console.error("Error handling all titles:", error);
        }

    };

    const handleChangeDiagnosis = (type) => {
        getData(type)
    }

    useEffect(() => {
        handleChangeDiagnosis(selectedModuleType.value)
    }, [selectedModuleType])


    useEffect(() => {
        if (selectedDiagnosis) {
            try {
                handleChangeDiagnosis(selectedModuleType.value)
            } catch (error) {
                console.error("Error updating diagnosis data:", error);
            }
        }
    }, [selectedDiagnosis])

    useEffect(() => {
        try {
            if (selectedTitles.length > 0) {
                handleAllStatement(selectedTitles)
            } else if (selectedTitles?.length === 0) {
                handleChangeDiagnosis(selectedModuleType.label)
            }
        } catch (error) {
            console.error(error)
        }
    }, [selectedTitles])

    useEffect(() => {
        if (selectedStatement) {
            handlePlanStatement(selectedStatement)
        }
    }, [selectedStatement])

    useEffect(() => {
        updateDiagnosisOptions()
        getData()
    }, [])


    const handleFilterOrder = (suggestionData) => {
        console.log("suggestionData", suggestionData)
        try {
            let orders = suggestionData.flatMap((suggestion) => {
                return suggestion.orders;

            });
            console.log("orders", orders)
            return orders;
        } catch (error) {
            console.error("Error filtering orders:", error);
            return []
        }
    };

    const handleFilterPlanSuggestion = (suggestionData) => {
        console.log("suggestionData plan===>", suggestionData, statementOption, selectedStatement)
        try {
            let planSuggestion = suggestionData.flatMap((suggestion) => {
                return suggestion.planSuggestions
                // return statementOption.flatMap((option) => {
                //     const filteredOrders = option?.orders?.planSuggestions.filter((plan) => plan.name === suggestion.label);
                //     return filteredOrders.length > 0 ? filteredOrders : [];
                // });
            });

            return planSuggestion;
        } catch (error) {
            console.error("Error filtering orders:", error);
            return [];
        }
    }


    const handleSubmit = () => {
        try {

            let suggestionText = type == 'plan' ? selectedPlan?.map(planStatement => planStatement) : selectedStatement?.map(suggestion => suggestion);
            // let suggestionText = selectedStatement?.map(suggestion => suggestion.label);

            console.log("plan suggestion", suggestionText);
            if (suggestionText) {

                const order = handleFilterOrder(suggestionText)
                const planSuggestion = handleFilterPlanSuggestion(suggestionText)

                console.log("plan suggesition order======>", order, planSuggestion)
                setParentAccordions((prev) => {
                    let updatedAccordions = type == 'plan' ? prev : prev.accordions;
                    if (!updatedAccordions || updatedAccordions.length === 0) {
                        const newAccordion = {
                            id: Date.now(),
                            title: null,
                            suggestions: {
                                // suggestionName: suggestionText,
                                suggestionName: suggestionText.map(statementData => ({
                                    name: statementData?.label, description: statementData?.value?.description || statementData?.description || "", attached: statementData.value?.attached || ""
                                })),
                                orders: [],
                                planSuggestions: [],
                                information: [],
                            },
                            children: [],
                        };
                        updatedAccordions = [newAccordion];
                    } else {
                        updatedAccordions = updateNestedSuggestions(
                            updatedAccordions,
                            parentId,
                            suggestionText.map(statementData => ({
                                name: statementData.label, description: statementData?.value?.description || statementData?.description || "", attached: statementData?.value?.attached || {
                                    image: [],
                                    video: [],
                                    document: []
                                }
                            })),
                            order, planSuggestion);
                    }


                    if (type == 'plan') {
                        toast.success('Statement Copied Successfully', toastConfig)
                        return updatedAccordions;
                    } else {
                        let updatedData = { ...prev, accordions: updatedAccordions };
                        toast.success('Statement Copied Successfully', toastConfig)
                        return updatedData;
                    }

                });
            }

        } catch (error) {
            console.error("Error copying statement:", error);
            toast.error('Statement Copy failed', toastConfig)

        } finally {

            setSuggestionModalVisible(false)
        }


    }


    const updateNestedSuggestions = (list, parentId, suggestion, orders, planSuggestions) =>
        list?.map((item) =>
            item.id === parentId
                ? {
                    ...item,
                    suggestions: {
                        ...item.suggestions,
                        suggestionName: [...item?.suggestions?.suggestionName, ...suggestion],
                        orders: [...item?.suggestions?.orders, ...orders],
                        planSuggestions: [...item?.suggestions?.planSuggestions, ...planSuggestions]
                    }
                }
                : {
                    ...item,
                    children: updateNestedSuggestions(item.children, parentId, suggestion, orders, planSuggestions)
                }
        );

    console.log("selectedPlan", selectedPlan)

    // console.log("selectedStatement===========>", selectedStatement)

    return (
        <div className='mx-5 patient-theme-copy-shell statement-copy-theme'>
            <div
                className="patient-theme-copy-panel statement-copy-theme__panel p-4"
                style={{
                    marginBottom: '20px',
                    width: '100%',

                }}
            >
                <div className=' '>

                    {differentModuleCopyFunctionality && <div className="mb-3" style={{ width: '100%' }}>
                        <CFormLabel className="patient-theme-copy-label">
                            Select Module
                        </CFormLabel>
                        <Select
                            value={selectedModuleType}
                            onChange={setSelectedModuleType}
                            options={moduleType}
                            isLoading={isPageLoading}
                            className="basic-single-select ui-react-select"
                            classNamePrefix="select"
                        />
                    </div>}

                    <div className="mb-3" style={{ width: '100%' }}>
                        <CFormLabel className="patient-theme-copy-label">
                            Select Diagnosis
                        </CFormLabel>
                        <Select
                            value={selectedDiagnosis}
                            onChange={setSelectedDiagnosis}
                            options={diagnosisOptions}
                            isLoading={isPageLoading}
                            className="basic-single-select ui-react-select"
                            classNamePrefix="select"
                        />
                    </div>

                    <CheckOptionSelections
                        options={titleOptions}
                        selectedValue={selectedTitles}
                        setSelectedValue={setSelectedTitles}
                        isPageLoading={isPageLoading}
                        Label={'Select Title'}
                    />


                    <CheckOptionSelections
                        options={statementOption.flatMap((item) => item.data || [])}
                        selectedValue={selectedStatement}
                        setSelectedValue={setSelectedStatement}
                        isPageLoading={isPageLoading}
                        Label={'Select Assessment'}
                    />
                    {type == 'plan' && <CheckOptionSelections
                        options={planOptions}
                        selectedValue={selectedPlan}
                        setSelectedValue={setSelectedPlan}
                        isPageLoading={isPageLoading}
                        Label={'Select Plan'}
                    />
                    }
                </div>

            </div>
            <div className='text-end'>
                <CButton onClick={handleSubmit} className='px-4 ui-action-btn ui-action-btn--primary'>Add</CButton>
            </div>
        </div>
    )
}

export default SuggestionCopy
